import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMinutemailerComponent } from './simple-icons-minutemailer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMinutemailerComponent ],
    exports:      [ SimpleIconsMinutemailerComponent ],
    bootstrap:    []
})
export class SimpleIconsMinutemailerModule {}
